import React, {useRef} from 'react';
import {Button} from "primereact/button";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useTranslate} from "../useTranslate";
import {OverlayPanel} from "primereact/overlaypanel";
import {logout} from "../../auth/auth-slice";
import {Dropdown} from "primereact/dropdown";
import {timeSince} from "../utils";
import 'react-flagpack/dist/style.css'
import {getSiteConfigs, setSiteConfigs} from "../storage";
import {fetchAppData} from "../app-slice";
import {MultiStateCheckbox} from "primereact/multistatecheckbox";
import LanguageItem from "./language-item";
import {ListBox} from "primereact/listbox";
import {Badge} from "primereact/badge";
import Avatar from "./avatar";

function Toolbar({setVisibleSidebar, visibleSidebar, pageConfig, onTitleClicked}) {
    const {config, pages, homePageIndex, notifications} = useSelector((state) => state.app);
    const {user} = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const translate = useTranslate();
    const navigate = useNavigate();
    const userRef = useRef();
    const notificationRef = useRef();
    const darkLightOptions = [{value:"dark", icon:"pi pi-moon"},{value:"light", icon:"pi pi-sun"}];

    const currentPage = pageConfig || pages[homePageIndex];
    const showHomePageButton = currentPage?.name !== pages[homePageIndex]?.name;
    const userDisplayName = [user?.firstname, user?.lastname].filter(Boolean).join(' ')
        || user?.username
        || user?.email
        || translate('admin');

    return (
        <div className={"w-full surface-ground border-bottom-1 border-200 flex align-items-center p-2 justify-content-between h-4rem"}>
            <div className="flex align-items-center gap-2">
                {config.sidebar?(<span className="pi pi-bars cursor-pointer" onClick={()=>{setVisibleSidebar(!visibleSidebar)}}/>):(showHomePageButton&&<span className="pi pi-chevron-right cursor-pointer" onClick={()=>{navigate("/")}}/>)}
                <div className="flex align-items-center gap-2 cursor-pointer" onClick={(e)=>{onTitleClicked?.(e)}}>
                    <span className="font-bold">{translate(currentPage?.name || config['app-name'])}</span>
                    {onTitleClicked && <i className="pi pi-cog text-xs text-500"/>}
                </div>
            </div>
            <div className="flex align-items-center gap-2">

                {config['dark-mode-switch']&&(
                    <div className="border-1 p-2 border-100 border-round flex gap-1 align-items-center ml-2">
                        <MultiStateCheckbox empty={false} value={config["dark-mode"]?"dark":"light"} defaultValue="light" onChange={(e) => {setSiteConfigs({...getSiteConfigs(), "dark-mode":e.value==="dark"}); dispatch(fetchAppData())}} options={darkLightOptions} optionValue="value" />
                        <span className="text-xs">{config["dark-mode"]?translate("dark"):translate("light")}</span>
                    </div>
                )}
                {config["multi-language"]&&<Dropdown className="text-xs" panelClassName={`${config.dir} text-xs`} options={config['support-languages']} value={config['support-languages'][config['support-languages'].findIndex(l=>l.code===(getSiteConfigs()&&getSiteConfigs().language?getSiteConfigs().language.code:config.language))]} valueTemplate={(option, props)=>(<LanguageItem option={option} props={props} />)} itemTemplate={(option, props)=>(<LanguageItem option={option} props={props} />)} onChange={(e)=>{setSiteConfigs({...getSiteConfigs(), language:e.value}); dispatch(fetchAppData())}}/>}
                <i className="text-2xl pi pi-bell bg-transparent p-overlay-badge pl-2 cursor-pointer" onClick={(e) => notificationRef.current.toggle(e)}>
                    {notifications.some(e=>!e.isRead)&&<Badge severity="danger" />}
                </i>
                <OverlayPanel className="w-20rem rtl text-xs" ref={notificationRef} pt={{root:{className:"rtl text-xs"}, content:{className:"text-xs"}}}>
                    <ListBox className="border-none text-xs" options={notifications?.map(e=>({label:translate(e.title), value:e.id, className:"p-0 border-round", data:e}))} itemTemplate={(option) => <ItemTemplate option={option} translate={translate}/>}/>
                </OverlayPanel>
                <Avatar size="large" className="text-xs font-bold" memberData={user} onClick={(e) => userRef.current.toggle(e)}/>
                <OverlayPanel className="w-14rem rtl text-xs" ref={userRef} pt={{root:{className:"rtl text-xs"}, content:{className:"p-0 text-xs"}}}>
                    <div className="flex flex-column gap-1">
                        <div className="flex flex-column gap-1 p-3 border-bottom-1 border-100">
                            <span className="text-xs font-bold text-900 white-space-nowrap overflow-hidden text-overflow-ellipsis">{userDisplayName}</span>
                            {user?.email && <span className="text-xs text-500 white-space-nowrap overflow-hidden text-overflow-ellipsis">{user.email}</span>}
                        </div>
                        {config['user-profile']&&(<Button className="p-2 text-xs p-button-text border-round-sm shadow-none" label={translate('user-account')} onClick={()=>{navigate('/user-account'); userRef.current.hide();}} />)}
                        <Button
                            icon="pi pi-sign-out"
                            className="p-2 text-xs p-button-text border-round-sm shadow-none justify-content-start gap-2"
                            label={translate('sign-out')}
                            onClick={()=>{
                                userRef.current.hide();
                                dispatch(logout());
                            }}
                        />
                    </div>
                </OverlayPanel>


            </div>


        </div>
    );
}

function ItemTemplate({option, translate}) {
    return(
        <div className="flex align-items-center justify-content-between border-round p-2 pr-2">
            <div className="flex gap-2 align-items-center">
                <i className={`pi ${!option.data.isRead?"pi-circle-fill text-primary-300":"pi-circle text-300"} text-xs`}/>
                <div className="flex flex-column">
                    <span className="text-xs">{option.label}</span>
                    <span className="text-xs text-300">{timeSince(new Date(option.data.createdAt)/1000, "YYYY/MM/DD", {translate})}</span>
                </div>
            </div>

            {/*{option.value>0&&<i className="pi pi-chevron-left text-xs"/>}*/}
        </div>
    )
}

export default Toolbar;
